import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import React, { useContext } from 'react';
import { Redirect } from 'react-router';
import { Dashboard } from '../components/expert';
import { UserContext } from '../contexts';

export const DashboardPage: React.FC = () => {
  const { isExpert } = useContext(UserContext);

  if (!isExpert) {
    return <Redirect to="/customer/experts" />;
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Dashboard</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <Dashboard />
      </IonContent>
    </IonPage>
  );
};
